(function () {
  function init(root) {
    if (!root || root.dataset.claimsReady === 'true') return;
    root.dataset.claimsReady = 'true';

    var perPage = parseInt(root.getAttribute('data-per-page') || '10', 10) || 10;
    var searchInput = root.querySelector('[data-claims-search]');
    var filterButtons = Array.prototype.slice.call(root.querySelectorAll('[data-filter]'));
    var rows = Array.prototype.slice.call(root.querySelectorAll('.cg-row'));
    var countEl = root.querySelector('[data-claims-count]');
    var emptyEl = root.querySelector('[data-claims-empty]');
    var pagination = root.querySelector('[data-claims-pagination]');
    var pagesEl = root.querySelector('[data-claims-pages]');
    var prevBtn = root.querySelector('[data-claims-prev]');
    var nextBtn = root.querySelector('[data-claims-next]');

    var activeFilter = 'all';
    var page = 1;

    function matchedRows() {
      var query = ((searchInput && searchInput.value) || '').trim().toLowerCase();
      return rows.filter(function (row) {
        var type = row.getAttribute('data-type') || '';
        var hay = ((row.getAttribute('data-search') || '') + ' ' + (row.textContent || '')).toLowerCase();
        var typeOk = activeFilter === 'all' || type === activeFilter;
        var queryOk = !query || hay.indexOf(query) !== -1;
        return typeOk && queryOk;
      });
    }

    function render() {
      var matched = matchedRows();
      var total = matched.length;
      var totalPages = Math.max(1, Math.ceil(total / perPage));
      if (page > totalPages) page = totalPages;

      rows.forEach(function (row) {
        row.hidden = true;
      });

      var start = (page - 1) * perPage;
      var visibleSlice = matched.slice(start, start + perPage);
      visibleSlice.forEach(function (row) {
        row.hidden = false;
      });

      if (countEl) {
        var startLabel = total ? start + 1 : 0;
        var endLabel = Math.min(start + perPage, total);
        countEl.textContent =
          total +
          ' product ' +
          (total === 1 ? 'group' : 'groups') +
          (total ? ' · showing ' + startLabel + '–' + endLabel : '');
      }

      if (emptyEl) emptyEl.hidden = total > 0;

      if (pagination) {
        pagination.hidden = total <= perPage;
      }

      if (pagesEl) {
        pagesEl.innerHTML = '';
        for (var i = 1; i <= totalPages; i++) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'cg-page-num';
          btn.textContent = String(i);
          if (i === page) btn.setAttribute('aria-current', 'page');
          btn.addEventListener(
            'click',
            (function (n) {
              return function () {
                page = n;
                render();
                root.scrollIntoView({ behavior: 'smooth', block: 'start' });
              };
            })(i)
          );
          pagesEl.appendChild(btn);
        }
      }

      if (prevBtn) prevBtn.disabled = page <= 1 || total === 0;
      if (nextBtn) nextBtn.disabled = page >= totalPages || total === 0;
    }

    if (searchInput) {
      searchInput.addEventListener('input', function () {
        page = 1;
        render();
      });
    }

    filterButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        activeFilter = button.getAttribute('data-filter') || 'all';
        filterButtons.forEach(function (item) {
          item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
        });
        page = 1;
        render();
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        if (page > 1) {
          page -= 1;
          render();
        }
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        page += 1;
        render();
      });
    }

    render();
  }

  function boot() {
    document.querySelectorAll('[data-claims-guide]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target) return;
    var root = event.target.querySelector('[data-claims-guide]');
    if (root) {
      root.dataset.claimsReady = 'false';
      init(root);
    }
  });
})();
